"use client";

import IcoMoon from "react-icomoon";
import { twMerge } from "tailwind-merge";

import useMobile from "@/hooks/use-mobile";
import { IconType } from "@/TS/Types/global_types";

import iconSet from "./../icomoon/selection.json";

// 🧙🏻‍♂️ DEV 💡 =========================================

// Use the function when you want to get all icon name

// const getIconsType = (iconSet: any) => {
//   const ICONS_ARRAY = iconSet.icons.map((icon: any) => icon.properties.name);
//   console.log(ICONS_ARRAY);
//   return ICONS_ARRAY as const;
// };
// getIconsType(iconSet)

// 🧙🏻‍♂️ DEV 💡 =========================================

export interface IconProps {
  isMobile?: boolean;
  size?: number;
  icon: IconType;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<SVGElement>) => void;
}

const Icon = (props: IconProps) => {
  const isMobile = useMobile();

  return (
    <IcoMoon
      onClick={props.onClick}
      size={isMobile && !props.size ? 22 : (props.size ?? 30)}
      iconSet={iconSet}
      className={twMerge(props.className)}
      {...props}
    />
  );
};

export default Icon;
